import {Navigate,useSearchParams} from 'react-router';
/** Preserve old bookmarks and selected building/invoice context in the canonical review. */
export function PayablesRedirect(){const [params]=useSearchParams();return <Navigate replace to={'/finance/payables?'+params.toString()}/>;}
